// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2_wTg","dragIcon":"SortableItem_dragIcon__TeS0S","disabled":"SortableItem_disabled__u9Mcf"};